import { render } from "./OfficeView.vue?vue&type=template&id=f9cf3258"
import script from "./OfficeView.vue?vue&type=script&lang=js"
export * from "./OfficeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__